export default {
    inheritAttrs: false,
    props: {
        src: {
            required: true,
            type: String,
        },
    },
}
